import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Avatar } from 'antd';

import { IGuestCartDetail } from 'api/guest_sdk';
import { Currency } from 'api/types/store';

import CountControls from 'components/Store/NewCheckout/CountControls';
import placeholder from 'components/Dashboard/Store/Products/images/placeholder.png';
import { EPriceType } from 'components/NewProductStepper/ProductBaseForm/constants';
import { getTimeLabel } from 'components/NewProductStepper/ProductBaseForm/utils';

import { formatCurrency } from 'utils';
import { Button, Typography } from 'ui-kit';
import Stack from 'ui-kit/Stack';

import './styles.scss';

export interface ICartItem {
  orderProduct: IGuestCartDetail['order_products'][number];
  currency: Currency;
  onDeductItem: () => void;
  onAddItem: () => void;
}

const CartItem = ({ orderProduct, currency, onAddItem, onDeductItem }: ICartItem) => {
  const history = useHistory();

  const handleEditOrderProduct = useCallback(() => {
    const queryParams = `?product=${orderProduct.product.id}&cartItem=${orderProduct.id}`;
    history.push({
      pathname: location.pathname,
      search: queryParams,
    });
  }, [orderProduct]);

  const productName = useMemo(() => {
    if (
      orderProduct.product_info.price_type === EPriceType.MULTIPLE &&
      orderProduct.product_price
    ) {
      return `${orderProduct.product_info.product_name} (${
        getTimeLabel({ value: orderProduct.product_price.time_label }) ||
        orderProduct.product_price.label
      })`;
    }
    return orderProduct.product_info.product_name;
  }, [orderProduct]);

  return (
    <div className="CartItem">
      <Avatar
        className="CartItem_image"
        src={orderProduct.product_info.image || placeholder}
        shape="square"
      />
      <div className="CartItem_body">
        <div className="CartItem_body-details">
          <Typography
            className="CartItem_body-details-title"
            variant="body2"
            color="textDark"
            rows={2}
          >
            {productName}
          </Typography>
          <Typography className="CartItem_body-details-price" variant="caption" color="secondary">
            {formatCurrency(orderProduct.amount, currency)}
          </Typography>
        </div>
        <div className="CartItem-actions">
          <Stack gap="8px">
            <Button
              className="CartItem-actions-edit-button"
              variant="text"
              color="textGray"
              onClick={handleEditOrderProduct}
            >
              Edit
            </Button>
          </Stack>
          <CountControls
            orderProduct={orderProduct}
            onDeduct={onDeductItem}
            onAddQuantity={onAddItem}
          />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
